import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import { action, observable, makeObservable } from 'mobx';
import {observer} from 'mobx-react';

import {Selector, Spinner} from '../../../components';
import EntityTaskStore from "./EntityTaskStore";
import {Task, WorkflowTaskStore} from '../task/WorkflowTaskStore';
import {TaskEditorModal} from "../task/WorkflowTaskEditor";

/**
 * This component renders a task dropdown and a "create task" button
 * Used for viewing tasks related to some other entity (review, listing, post, etc)
 */
const EditCreateTask = observer(class EditCreateTask extends Component {
  static propTypes = {
    entity: PropTypes.any.isRequired,
    entityId: PropTypes.string.isRequired,
    newTaskData: PropTypes.any.isRequired,
    user: PropTypes.object.isRequired,
    onShowModal: PropTypes.func,
    onHideModal: PropTypes.func
  };

  static defaultProps = {
    onShowModal: (component) => {},
    onHideModal: () => {}
  }

  entityTasksStore = null;
  editStore = null;
  selectedTask = null;

  modal = null;

  constructor(props){
    super(props);

    makeObservable(this, {
      entityTasksStore: observable,
      editStore: observable,
      selectedTask: observable,
      modal: observable,
      componentWillMount: action,
      componentWillUnmount: action,
      onTaskSelect: action,
      onCreateTaskClick: action
    });
  }

  componentWillMount() {
    this.entityTasksStore = new EntityTaskStore();
  }

  componentDidMount(){
    this.entityTasksStore.loadTasksByEntityId(this.props.entityId);
  }

  componentWillUnmount() {
    this.entityTasksStore = null;
  }

  onTaskSelect = (task) => {
    const editStore = new WorkflowTaskStore({ task, taskData: this.props.entity });
    this.props.onShowModal(<TaskEditorModal store={editStore} onClose={this.props.onCloseModal} />)
  };

  onCreateTaskClick = () => {

    const createStore = new WorkflowTaskStore({
      taskTemplate: Task(this.props.newTaskData),
      taskData: this.props.entity
    });
    this.props.onShowModal(
      <TaskEditorModal store={createStore} onClose={this.props.onCloseModal}/>
    )
  };


  render() {
    const {entityTasksStore} = this;
    const {tasks} = entityTasksStore;
    let spinnerOrSelector = this.entityTasksStore.loading ? <Spinner center size="md" timeout={0} /> : <Selector
      required={true}
      placeholder={tasks.length ? 'Select a task' : 'No Tasks'}
      disabled={!tasks.length}
      getKey={x => x._id}
      options={tasks}
      renderOption={opt => opt.content.taskName}
      selected={this.selectedTask}
      onSelected={this.onTaskSelect}
    />
    return (
      <Fragment>
        {spinnerOrSelector}
        <div className="text-right mt-4">
          <button
            className="btn btn-outline-secondary"
            onClick={this.onCreateTaskClick}
          >Create Task</button>
        </div>
        {
          this.modal
        }
      </Fragment>
    );
  }
});

export default EditCreateTask;
